import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';
import { RequireStaff } from '@features/cms/components/RequireStaff.tsx';

const CommissionsPage = lazyWithRetry(() => import('../pages/CommissionsPage.tsx'));

const CommissionAgreementsPage = lazyWithRetry(() =>
  import('../pages/CommissionAgreementsPage.tsx'),
);

const CommissionsNode = () => (
  <RequireStaff requiredApps={['erp', 'erp__rrhh']} render={() => <CommissionsPage />} />
);

const CommissionAgreementsNode = () => (
  <RequireStaff requiredApps={['erp', 'erp__rrhh']} render={() => <CommissionAgreementsPage />} />
);

const commissionsNode = {
  component: CommissionsNode,
} satisfies ComponentPage;

const commissionAgreementsNode = {
  component: CommissionAgreementsNode,
} satisfies ComponentPage;

const commissionsRoutes: ComponentOrMapping = {
  erp: {
    commissions: commissionsNode,
    configuration: {
      commissions: commissionAgreementsNode,
    },
  },
};

export default commissionsRoutes;
